import axiosRequest from "api";
import { payloadHelper } from "helpers/payload-helper";
import { ApiResponse } from "types/api";

import {
  ChangePasswordFormType,
  ForgotPasswordFormType,
  LoginFormType,
  LoginResponse,
  RegisterFormType,
  VerifyTokenPayload,
} from "./type";

export const AuthApi = {
  login: (typename: string, payload: LoginFormType) =>
    axiosRequest.post<LoginResponse>(
      "/",
      payloadHelper("MemberLogin", typename, payload)
    ),
  register: (typename: string, payload: RegisterFormType) =>
    axiosRequest.post<ApiResponse>(
      "/",
      payloadHelper("MemberRegister", typename, payload)
    ),
  forgotPassword: (typename: string, payload: ForgotPasswordFormType) =>
    axiosRequest.post<ApiResponse>(
      "/",
      payloadHelper("ForgotPassword", typename, payload)
    ),
  async changePassword(typename: string, payload: ChangePasswordFormType) {
    const response = await axiosRequest.post<ApiResponse>(
      "/",
      payloadHelper("ChangePassword", typename, payload)
    );
    return response.data;
  },
  async verifyToken(typename: string, payload: VerifyTokenPayload) {
    const { data } = await axiosRequest.post<ApiResponse>(
      "/",
      payloadHelper("VerifyToken", typename, payload)
    );
    return data;
  },
};
